import { useState } from "react";

import Button from "../../components/button";
import Checkbox from "../../components/checkbox";
import OptionChooser from "../../components/optionChooser";
import PopUp from "../../components/popUp";
import { useAppContext } from "../../context/appContext";
import "./addCreditPopUp.css";

export default function AddCreditPopUp() {

    const {purchaseController, sessionId} = useAppContext();

    const [amount, setAmount] = useState<keyof typeof moneyOptions>();
    const [agb, setAgb] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const moneyOptions = {
        "10€": 10,
        "20€": 20,
        "30€": 30,
        "40€": 40,
        "50€": 50
    }

    async function pay() {
        if(!agb) {
            setError("You need to agree to the terms and conditions.");
            return;
        }
        setLoading(true);
        await purchaseController.pushAccountCreditCommit(sessionId, {
            amount: moneyOptions[amount ? amount : "10€"]
        }).catch((e) => {
            setError("An error occurred while processing your payment. Please try again later.");
        }).then((response) => {
            window.open(response?.data.stripeCheckout.sessionUrl, "_self");
        });
        setLoading(false);
    }

    return <PopUp title="Add Account Credit" className="big">
        <OptionChooser options={Object.keys(moneyOptions)} label="Amount" setActive={(v: string) => setAmount(v as keyof typeof moneyOptions)} active={amount}/>
        <p className="marginTop">By buying pieces directly through your Account credit, you will save on Transaction fees, hence giving you a discount. The artists will still get the same Revenue off of your purchases.</p>
        <Checkbox className="marginTop" label={<>I confirm that I have read and agree to the <a onClick={() => {
            window.open("/terms", "_blank");
        }}>terms of use</a>.</>} value={agb} onClick={(v: boolean) => setAgb(v)}/>
        <p className="error">{error}</p>
        <Button loading={loading} onClick={pay}>Pay now</Button>
    </PopUp>
    
}